var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.16732V7.33398C5.5 4.29982 6.41667 1.83398 11 1.83398C15.5833 1.83398 16.5 4.29982 16.5 7.33398V9.16732",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 16.9583C12.2656 16.9583 13.2916 15.9323 13.2916 14.6667C13.2916 13.401 12.2656 12.375 10.9999 12.375C9.73427 12.375 8.70825 13.401 8.70825 14.6667C8.70825 15.9323 9.73427 16.9583 10.9999 16.9583Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 20.166H6.41659C2.74992 20.166 1.83325 19.2493 1.83325 15.5827V13.7493C1.83325 10.0827 2.74992 9.16602 6.41659 9.16602H15.5833C19.2499 9.16602 20.1666 10.0827 20.1666 13.7493V15.5827C20.1666 19.2493 19.2499 20.166 15.5833 20.166Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDark);
export default __webpack_public_path__ + "static/media/lock-dark.b8e3c3fe5957b1fbae06419f184b1f85.svg";
export { ForwardRef as ReactComponent };